import { render, staticRenderFns } from "./DinoName.vue?vue&type=template&id=6849f9e9&scoped=true&"
import script from "./DinoName.vue?vue&type=script&lang=ts&"
export * from "./DinoName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6849f9e9",
  null
  
)

export default component.exports